import { newGraphStep } from './newGraphStep.js';

export const addStepToGraph = ({ graph, stepId, parentStepId, relation, index, step }) => {
  const currentParent = { ...(graph?.[parentStepId] || newGraphStep()) };

  graph[stepId] = step || newGraphStep();

  // If a normal exit node,
  if (relation === 'exit') {
    graph[stepId].exit = currentParent?.exit;
    if (parentStepId) {
      graph[parentStepId] = graph[parentStepId] || newGraphStep();
      graph[parentStepId].exit = stepId;
    }
  }

  if (relation === 'child') {
    graph[stepId].exit = currentParent.child;
    if (parentStepId) {
      graph[parentStepId] = graph[parentStepId] || newGraphStep();
      graph[parentStepId].child = stepId;
    }
  }

  if (relation === 'branch') {
    graph[stepId].exit = currentParent?.branches?.[index];
    if (parentStepId) {
      graph[parentStepId] = graph[parentStepId] || newGraphStep();
      graph[parentStepId].branches[index] = stepId;
    }
  }

  return graph;
};
